import { getFramework } from '@/framework';
import { REFERENCE_LINE_DIRECTION, ReferenceLine, type ReferenceLineDirection } from '@/version-types';
import { getReferenceLinesState } from '../states/reference-lines-state';
import { ReferenceLineHistoryType } from '../types';
import { genReferenceLineId, getDefaultReferenceLine } from '../utils';

export class AddReferenceLine {
    constructor(private id: string) {}

    add(direction: ReferenceLineDirection, pushHistory = true) {
        const framework = getFramework(this.id);
        const scale = framework.stage.getScale();
        const viewHeight = framework.stage.getViewHeight();
        const viewWidth = framework.stage.getViewWidth();
        const padding = framework.stage.getViewPortPadding();
        const viewPaddingLeft = padding;
        const viewPaddingTop = padding;

        // 舞台宽高
        const stageSize = framework.stage.getSize();

        const { left: x, top: y } = framework.stage.getStageScrollPosition();

        let position = 0;
        if (direction === REFERENCE_LINE_DIRECTION.HORIZONTAL) {
            const contentHeight = stageSize.height * scale;
            let paddingTop = viewPaddingTop;
            // 内容高度小于视窗高度
            if (viewHeight - paddingTop > contentHeight) {
                paddingTop = (viewHeight - contentHeight) / 2;
            }
            position = viewHeight / 2 - paddingTop + y;
        } else {
            const contentWidth = stageSize.width * scale;
            let paddingLeft = viewPaddingLeft;
            // 内容宽度小于视窗宽度
            if (viewWidth - paddingLeft > contentWidth) {
                paddingLeft = (viewWidth - contentWidth) / 2;
            }
            position = viewWidth / 2 - paddingLeft + x;
        }

        const newLine = {
            id: genReferenceLineId(),
            position: Math.round(position / scale),
            direction,
        };

        const result = this.addWithLineData(newLine, pushHistory);
        return result;
    }
    addWithLineData(line: Partial<ReferenceLine>, pushHistory = true) {
        const framework = getFramework(this.id);
        const result = getDefaultReferenceLine(line);
        getReferenceLinesState(this.id).addReferenceLine(result);
        getReferenceLinesState(this.id).setShowReferenceLines(true);

        // 写入历史记录
        if (pushHistory) {
            framework.history.write({
                type: ReferenceLineHistoryType.ADD,
                data: {
                    item: result,
                },
            });
        }

        return result;
    }
}
